import { supabaseClient } from '../config/supabase';

export const MESSAGE_TEMPLATES_MANAGE_FUNCTION = 'message-templates-manage';
export const MESSAGE_TEMPLATES_SYNC_FUNCTION = 'message-templates-sync';

async function unwrapFunctionResult(invocationPromise, defaultErrorMessage) {
    const { data, error } = await invocationPromise;
    if (error) {
        throw new Error(error.message || defaultErrorMessage);
    }
    if (data?.ok === false) {
        throw new Error(typeof data.error === 'string' ? data.error : defaultErrorMessage);
    }
    return data ?? null;
}

export async function manageMessageTemplate(payload, { client = supabaseClient } = {}) {
    return unwrapFunctionResult(
        client.functions.invoke(MESSAGE_TEMPLATES_MANAGE_FUNCTION, { body: payload || {} }),
        'Could not manage message template.'
    );
}

export async function syncMessageTemplates(payload = {}, { client = supabaseClient } = {}) {
    return unwrapFunctionResult(
        client.functions.invoke(MESSAGE_TEMPLATES_SYNC_FUNCTION, { body: payload || {} }),
        'Could not sync message templates.'
    );
}
